import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import styled, { ThemeProvider } from 'styled-components';
import Typography from '../../common-components/Typography';
import vmTheme from '../../constants/theme';
import { font } from '../../constants/font';
import ContentValue from "../../constants/lang/en.json";
import Action from '../../common-components/Action';
import openUrl from '../../helper/openUrl';
import { STATIC_PATH } from '../../constants/config';

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  padding: 5%;
  height: 100vh;
  width: 100vw;
`;

const Image = styled.img`
  height: 286.8px;
  width: 400px;
`;

const DeletedPage = () => {
  const theme = useSelector((state) => state.app.get('theme'));
  return (
    <IntlProvider locale="en" messages={{ ...ContentValue }}>
      <ThemeProvider theme={vmTheme[theme]}>
        <Container>
          <Typography
            innerContent={"This project has been deleted."}
            display="block"
            padding={"10px 20px"}
            color={vmTheme[theme].contactLabelTextColor}
            align="center"
            enableTrim={false}
            font={font.bold_45_57_ptsans}
          />
          <Image
            src={`${STATIC_PATH}wait.png`}
            alt="deleted-project" />
          <Action
            background={vmTheme[theme].hoverBorderColor}
            hover
            borderRadius={"5px"}
            fontColor={vmTheme[theme].polarColor}
            width={"120px"}
            height={"40px"}
            margin={"9px 16px"}
            text={"DASHBOARD"}
            font={font.boldBase_700}
            onClick={() => openUrl(`${window.location.origin}/dashboard/`, true)}
          />
        </Container>
      </ThemeProvider>
    </IntlProvider>
  );
};

export default DeletedPage